import './bootstrap';
require('jquery.steps')

$(window).on('load', function () { // makes sure the whole site is loaded
    $('.loader').fadeOut(); // will first fade out the loading animation
    $('.loader-bg').delay(250).fadeOut('slow'); // will fade out the white DIV that covers the website.
    $('body').delay(250).css({'overflow': 'visible'});
})

$(" #filters-id a ").click(function () {
    $(' #filters-id a ').removeClass('btn-shadow');
    $(' #filters-id a div').removeClass('btn-shadow').removeClass('red-btn').addClass('unactive-btn');
    $(this).addClass('btn-shadow');
    $(this).find('div').addClass('red-btn').removeClass('unactive-btn');
});

$(document).ready(function () {
    $(' #modalButton ').click()
});

